module.exports = __webpack_public_path__ + "img/8bf72a2f33c5281ec61b56cb6cab03f2.png";